import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {cleanJsonSpecifikacija} from "../../../redux/helpers";
import Notification from "../../../common/Notification";
import {connect} from "react-redux";
import SpecPcelarstvo from "./SpecPcelarstvo";
import {getUser} from "../../../redux/user/reducer";
import {getSpecPcelarstvo} from "../../../redux/specPcelarstvo/reducer";
import {bindActionCreators, compose} from "redux";
import {createSpecPcelarstvoRequest, fetchNewSpecPcelarstvo} from "../../../redux/specPcelarstvo/fetch";
import {getLookupMap} from "../../../redux/lookup/reducer";
import {fetchLookups} from "../../../redux/lookup/fetch";
import {withStyles} from "@material-ui/core/styles";
import globalStyles from "../../styles";
import {CreateSpecRastitelno} from "../rastitelno/CreateSpecRastitelno";

export class CreateSpecPcelarstvo extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.saveSpecPcelarstvo = this.saveSpecPcelarstvo.bind(this);
        this.redirectToSpecPcelarstvoList = this.redirectToSpecPcelarstvoList.bind(this);
        this.state = {notify: false, message: '', error: false};
    }

    componentWillMount() {
        const {fetchNewSpecPcelarstvo, fetchLookups} = this.props;
        fetchNewSpecPcelarstvo();
        fetchLookups();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.error === false) {
            this.showNotification("Успешно креирана спецификација!");
            setTimeout(() => this.redirectToSpecPcelarstvoList(), 1000); //execute greet after 2000 milliseconds (2 seconds)
        } else if (nextProps.error === true) {
            this.showNotification("Грешка при креирање на спецификацијата!", false)
        }
    }

    saveSpecPcelarstvo(values) {
        /*  Create and call updateSpecPcelarstvo action */
        values.creatorId = this.props.user.id
        let newValues = cleanJsonSpecifikacija(JSON.parse(JSON.stringify(values)), true);
        this.props.createSpecPcelarstvoRequest(newValues)
        this.showNotification("Успешно креирана спецификација!");
        setTimeout(() => this.redirectToSpecPcelarstvoList(), 1000); //execute greet after 2000 milliseconds (2 seconds)
    }

    redirectToSpecPcelarstvoList() {
        this.props.history.push(`/SpecPcelarstvoList`);
    }

    showNotification = (msg, err) => {
        if (err) {
            this.setState({notify: true, message: msg, error: true});
        } else {
            this.setState({notify: true, message: msg, error: false});
        }
        setTimeout(() => this.setState({notify: false, message: "", error: false}), 5000);
    };

    handleNotificationClosed = () => {
        this.setState({
            notify: false
        });
    };

    render() {
        const {notify, message, error} = this.state;
        const {classes} = this.props;
        return (
            <div>
                <Card style={{boxShadow: "none", border: 0}}>
                    <CardContent className={classes.noPrint}>
                        <h1>Креирај спецификација</h1>
                    </CardContent>
                    {this.props.specPcelarstvo &&
                        <SpecPcelarstvo
                            specPcelarstvo={this.props.specPcelarstvo.specPcelarstvo}
                            createMode
                            onSubmit={this.saveSpecPcelarstvo}
                            onCancel={this.redirectToSpecPcelarstvoList}
                            user={this.props.user}
                            lookupData={this.props.lookupData}
                        />
                    }
                </Card>

                <Notification
                    notify={notify}
                    message={message}
                    error={error}
                    closed={this.handleNotificationClosed}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    return {
        id: id,
        specPcelarstvo: getSpecPcelarstvo(state),
        user: getUser(state),
        lookupData: getLookupMap(state)
    };
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({fetchNewSpecPcelarstvo, createSpecPcelarstvoRequest, fetchLookups}, dispatch)
}

CreateSpecPcelarstvo.propTypes = {
    dispatch: PropTypes.func
};

CreateSpecPcelarstvo.contextTypes = {
    router: PropTypes.object
};
export default compose(
    withStyles(globalStyles),
    connect(mapStateToProps, mapDispatchToProps)
)(CreateSpecPcelarstvo);